/**
 * Created by noam on 4/26/15.
 *
 * tooltip and bubble are optional.
 * can't be both properties defined.
 * bubble is defined either with the bubbleText field either with the bubbleContentView field
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Backbone = require("backbone");
    var Marionette = require("marionette");
    var Tooltip = require("ui/tooltip/Tooltip");
    var Bubble = require("ui/bubble/Bubble");
    var DEFAULT_TOOLTIP_POSITION = Tooltip.POSITION.RIGHT;
    var DEFAULT_TOOLTIP_ALIGN = Tooltip.ALIGN.MIDDLE;
    var DEFAULT_BUBBLE_POSITION = Bubble.POSITION.RIGHT;
    var DEFAULT_BUBBLE_ALIGN = Bubble.ALIGN.MIDDLE;
    var EMPTY_LABEL = "";
    var KEYS = {
        LABEL: "label",
        ENABLED: "enabled",
        CHECKED: "checked",
        EMBEDDED_VIEW: "embeddedView",
        TOOLTIP: "tooltip",
        TOOLTIP_POSITION: "tooltipPosition",
        TOOLTIP_ALIGN: "tooltipAlign",
        BUBBLE_TEXT: "bubbleText",
        BUBBLE_CONTENT_VIEW: "bubbleContentView",
        BUBBLE_POSITION: "bubblePosition",
        BUBBLE_ALIGN: "bubbleAlign"
    };
    var RadioButtonModel = Backbone.Model.extend({
        EMPTY_LABEL: EMPTY_LABEL,
        defaults : {
            key: "",
            label: EMPTY_LABEL,
            tooltip: "",
            tooltipPosition: DEFAULT_TOOLTIP_POSITION,
            tooltipAlign: DEFAULT_TOOLTIP_ALIGN,
            checked : false,
            enabled : true,
            embeddedView: null, //todo add documentation
            bubbleText: "",
            bubbleContentView: null,
            bubblePosition: DEFAULT_BUBBLE_POSITION,
            bubbleAlign: DEFAULT_BUBBLE_ALIGN
        },
        idAttribute: "key",
        initialize: function(options){
            if (!this.areTooltipAndBubbleValid()){
                this.logger.error("both tooltip and bubble are defined. Only one of them is allowed.", "RadioButtonModel:initialize");
                this.logger.graph({ name: "UIComponents:RadioButtonModel:bothTooltipAndBuubleErr"});

                throw new Error("RadioButtonModel: both tooltip and bubble are defined. Only one of them is allowed.");
            }
        },
        getLabel: function(){
            return this.get(KEYS.LABEL);
        },
        getSelected: function(){
            return this.get(KEYS.CHECKED);
        },
        getEnabled: function() {
            return this.get(KEYS.ENABLED);
        },
        setSelected: function(value){
            return this.set("checked",value);
        },
        setEnabled: function(value) {
            return this.set("enabled",value);
        },
        getEmbeddedView: function(){
            return this.get(KEYS.EMBEDDED_VIEW);
        },
        getTooltip: function(){
            return this.get(KEYS.TOOLTIP);
        },
        getTooltipPosition: function(){
            return this.get(KEYS.TOOLTIP_POSITION);
        },
        getTooltipAlign: function(){
            return this.get(KEYS.TOOLTIP_ALIGN);
        },
        getBubbleText: function(){
            return this.get(KEYS.BUBBLE_TEXT);
        },
        getBubbleContentView: function(){
            return this.get(KEYS.BUBBLE_CONTENT_VIEW);
        },
        getBubblePosition: function(){
            return this.get(KEYS.BUBBLE_POSITION);
        },
        getBubbleAlign: function(){
            return this.get(KEYS.BUBBLE_ALIGN);
        },
        isTooltipDefined: function(){
            return !_.isEmpty(this.getTooltip());
        },
        isBubbleTextDefined: function(){
            return !_.isEmpty(this.getBubbleText());
        },
        isBubbleContentViewDefined: function(){
            return this.getBubbleContentView() instanceof Marionette.ItemView;
        },
        isBubbleDefined: function(){
            return this.isBubbleTextDefined() || this.isBubbleContentViewDefined();
        },
        areTooltipAndBubbleValid: function(){
            return !(this.isTooltipDefined() && this.isBubbleDefined());
        }

    });

    return RadioButtonModel;
});
